/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ContractRentDrupoz } from './contractRentDrupoz.model';
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { RentType } from './rentType.model';
import { SubstateFlagType } from './substateFlagType.model';
import { ContractParamTemplate } from './contractParamTemplate.model';
import { ValorizationType } from './valorizationType.model';
import { DocumentTemplate } from './documentTemplate.model';
import { ContractPaymentDataDto } from './contractPaymentDataDto.model';
import { VersionType } from './versionType.model';
import { ContractRentUnknown } from './contractRentUnknown.model';


export interface ContractResponseDto { 
    appendixNumber?: number;
    appendixNumberMax?: number;
    appendixSourceId?: number;
    autoProlongationMonths?: number;
    autoProlongationMonthsUnit?: string;
    autoProlongationRepeatedly?: boolean;
    contractNumber?: number;
    contractNumberCustom?: string;
    contractNumberFormat?: string;
    contractNumberOfficial?: string;
    contractRentDrupozCollection?: Array<ContractRentDrupoz>;
    contractRentUnknownCollection?: Array<ContractRentUnknown>;
    contractYear?: number;
    counterpartyNumber?: string;
    createIndividualDocuments?: boolean;
    documentNote?: string;
    documentTemplate?: DocumentTemplate;
    durationMonths?: number;
    durationMonthsUnit?: string;
    durationToDate?: string;
    endDate?: string;
    endDateComputed?: string;
    endType?: string;
    expirationDate?: string;
    extended?: boolean;
    firstNoticeAfterMonths?: number;
    firstNoticeAfterMonthsUnit?: string;
    furtherRentPossible?: boolean;
    groupId?: number;
    id?: number;
    imported?: boolean;
    indefinite?: boolean;
    inflationLimit?: number;
    isWatched?: boolean;
    lastNoticeBeforeMonths?: number;
    lastNoticeBeforeMonthsUnit?: string;
    lvFullInfo?: string;
    note?: string;
    noticePeriodMonths?: number;
    noticePeriodMonthsUnit?: string;
    owners?: Array<SubjectContactResponseDto>;
    paramTemplate?: ContractParamTemplate;
    payTaxOwner?: boolean;
    paymentDatas?: Array<ContractPaymentDataDto>;
    paymentInKind?: boolean;
    paymentsFromEconomicYear?: boolean;
    payoutTo?: SubjectContactResponseDto;
    priceContract?: number;
    priceContractComputed?: number;
    priceDeal?: number;
    priceDealPercentageValorization?: number;
    priceDealValorization?: number;
    rentType?: RentType;
    reqNewAppendixAfterReprice?: boolean;
    resignDate?: string;
    reusedPreviousExpiration?: boolean;
    revisionId?: number;
    sentForSignature?: boolean;
    signatureDate?: string;
    signingProcess?: boolean;
    state?: string;
    stateOrder?: number;
    subcontract?: boolean;
    substateFlag?: SubstateFlagType;
    successiveNextId?: number;
    successiveNumber?: number;
    successiveSourceId?: number;
    taxConcerned?: boolean;
    taxOwner?: number;
    taxOwnerComputed?: number;
    taxOwnerTo?: SubjectContactResponseDto;
    taxTenant?: number;
    taxTenantComputed?: number;
    tenantHasPreemption?: boolean;
    tenants?: Array<SubjectContactResponseDto>;
    toEconomicYear: boolean;
    useRentDrupoz?: boolean;
    validity?: string;
    validityExplanation?: string;
    valorizationType?: ValorizationType;
    valorizeOrInflateToDate?: string;
    versionType?: VersionType;
    watchReason?: string;
}
export namespace ContractResponseDto {
}


